import { Divider, TextField, Typography } from '@mui/material';
import React from 'react';
import DocumentsTable from './components/DocumentsTable';
import OperationResume from '../OperationResume';

const DatesSelector = (props: any) => {
  const {
    selectedDocuments,
    setSelectedDocuments,
    exchangeDay,
    canForcePaymentDate,
    minimumDays,
    operationDate,
    setOperationDate,
    business,
    productType,
    operationDateDate,
    setOperationDateDate,
  } = props;

  const resetSelectedDocumentsDates = () => {
    setSelectedDocuments(
      selectedDocuments.map((doc: any) => ({
        ...doc,
        dueDate: undefined,
        paymentDate: undefined,
        tempDueDate: '',
        daysToCount: undefined,
      })),
    );
  };

  return (
    <div>
      <OperationResume
        stakeholderName={business.businessName}
        stakeholderIdentifier={business.identifier}
        documents={selectedDocuments}
        productType={productType}
      />
      <Divider />
      <div style={{ padding: '20px 0px' }}>
        <Typography variant="h6">Selecciona la fecha de operación.</Typography>
        <div style={{ marginTop: 10 }}>
          <TextField
            id="outlined-basic-two"
            label="Fecha de operación"
            variant="outlined"
            type="date"
            value={operationDate}
            fullWidth
            onChange={(e) => {
              setOperationDate(e.target.value);
              setOperationDateDate(new Date(e.target.value));
              resetSelectedDocumentsDates();
            }}
          />
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography padding="0px 0px 8px" variant="h6">
          Documentos seleccionados:
        </Typography>
      </div>
      <DocumentsTable
        selectedDocuments={selectedDocuments}
        setSelectedDocuments={setSelectedDocuments}
        exchangeDay={exchangeDay}
        canForcePaymentDate={canForcePaymentDate}
        minimumDays={minimumDays}
        operationDate={operationDateDate}
      />
    </div>
  );
};

export default DatesSelector;
